import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import InboxIcon from '@mui/icons-material/MoveToInbox'
import MailIcon from '@mui/icons-material/Mail'

type Anchor = 'top' | 'left' | 'bottom' | 'right'
type MenuType = {
    id: number
    name: string
    icon?: any
}
type MenuDrawerProps = {
    children?: React.ReactNode
    onClickMenu?: (item: MenuType) => void
    onClose?: () => void
    onClickBackdrop?: () => void
    dataSource?: MenuType[]
    isOpen: boolean
    position?: Anchor
    hideBackdrop?: boolean
    overrideClass?: {}
    inlineStyle?: {}
}

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
})

const DrawerControl = (props: MenuDrawerProps) => {
    const {
        children,
        dataSource,
        onClickMenu,
        onClose,
        onClickBackdrop,
        isOpen,
        position = 'left',
        hideBackdrop = false,
        overrideClass,
        inlineStyle,
    } = props
    const classes = useStyles()

    const list = (position: Anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: position === 'top' || position === 'bottom',
            })}
            onClick={onClose}
        >
            <List>
                {dataSource?.map((item: MenuType, index: number) => (
                    <ListItem
                        button
                        key={index}
                        onClick={() => {
                            onClickMenu && onClickMenu(item)
                        }}
                    >
                        {item?.icon ? (
                            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                        ) : null}
                        <ListItemText primary={item.name} />
                    </ListItem>
                ))}
            </List>
        </div>
    )

    return (
        <Drawer
            anchor={position}
            open={isOpen}
            onClose={onClose}
            hideBackdrop={hideBackdrop}
            ModalProps={{ onBackdropClick: onClickBackdrop }}
            classes={overrideClass}
            style={inlineStyle}
        >
            {dataSource ? list(position) : children}
        </Drawer>
    )
}

export default DrawerControl
